import { css } from '@emotion/css';

import { Color } from '../../../../../../styles';

export const fieldLabel = css`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  padding: 15px 0px;
  color: ${Color.GRAYSCALE.GRAY8};
`;

export const fieldValue = css`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  color: ${Color.GRAYSCALE.GRAY10};
`;

export const bodyWrapper = css`
  margin-bottom: 20px;
  .ant-col {
    height: 56px;
    > span {
      display: table-cell;
      vertical-align: middle;
    }
  }
`;

export const alignRight = css`
  display: table;
  text-align: right;
`;

export const borderBottom = css`
  border-bottom: 1px solid #f0f0f0;
`;

export const titleWrapper = css`
  margin-bottom: 36px;

  h1 {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 36px;
    color: ${Color.BRAND.BRAND6};
  }

  span {
    font-family: 'Source Sans Pro';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${Color.GRAYSCALE.GRAY7};
  }
`;

export const submissionStatusHeader = css`
  margin-bottom: 28px;
`;

export const submissionSuccessStatus = css`
  color: ${Color.GREEN.GREEN6};
`;

export const submissionFailedStatus = css`
  color: ${Color.RED.RED6};
`;

export const submissionStatus = css`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
`;

export const securityHeader = css`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  color: ${Color.GRAYSCALE.GRAY10};
`;

export const imageWrapper = css`
  width: 31px;
  height: 31px;
`;

export const alignCenter = css`
  display: table;
  text-align: center;
`;

export const totalInvestmentWrapper = css`
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  color: ${Color.GRAYSCALE.GRAY8};
  b {
    font-weight: 600;
    line-height: 26px;
  }
`;
